import { ReactNode } from 'react'
import * as React from 'react'
type Props = {
  children?: ReactNode
  color?: string
  width?: string
  height?: string
}

const ShareIcon: React.FunctionComponent<Props> = () => {
  //const { width, height, color } = props

  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.75018 3.24973H10.3727V2.06023C10.3727 1.7636 10.4608 1.47365 10.6256 1.22704C10.7904 0.980425 11.0247 0.788215 11.2987 0.67471C11.5728 0.561205 11.8743 0.531501 12.1652 0.589352C12.4562 0.647203 12.7234 0.790013 12.9332 0.999727L17.3432 5.40898C17.765 5.83091 18.002 6.40311 18.002 6.99973C18.002 7.59635 17.765 8.16854 17.3432 8.59048L12.9332 12.9997C12.7234 13.2094 12.4562 13.3523 12.1652 13.4101C11.8743 13.468 11.5728 13.4382 11.2987 13.3247C11.0247 13.2112 10.7904 13.019 10.6256 12.7724C10.4608 12.5258 10.3727 12.2359 10.3727 11.9392V10.7497H6.00018C4.80707 10.7509 3.66317 11.2254 2.81952 12.0691C1.97586 12.9127 1.50138 14.0566 1.50018 15.2497C1.50018 15.4486 1.42117 15.6394 1.28051 15.7801C1.13986 15.9207 0.949097 15.9997 0.750183 15.9997C0.551271 15.9997 0.360506 15.9207 0.219852 15.7801C0.0792007 15.6394 0.000183105 15.4486 0.000183105 15.2497V9.99973C0.00216866 8.21013 0.713964 6.49439 1.9794 5.22895C3.24485 3.96351 4.96058 3.25171 6.75018 3.24973Z"
        fill="#1A1E3D"
      />
    </svg>
  )
}

export default ShareIcon
